<div
    class="card dynamic-task-card"
    [ngClass]="{
        'dynamic-refunding-card': !isDone,
        'dynamic-done-card': isDone,
        'dynamic-card-expanded': !isDone && !isCollapsed
    }"
>
    <span
        *ngIf="badgeText && !groupCollapsed"
        class="dynamic-sequence-number"
        aria-hidden="true"
    >
        {{ badgeText }}
    </span>
    <div class="card-header" (click)="toggleCard()">
        <div class="dynamic-task-selector">
            <span *ngIf="isDone" class="dynamic-completed-check">
                <i class="fa fa-check" aria-hidden="true"></i>
            </span>
            <span *ngIf="!isDone" class="dynamic-refunding-icon">
                <i class="fa fa-undo" aria-hidden="true"></i>
            </span>
        </div>
        <div class="dynamic-task-summary">
            <div class="dynamic-task-title">
                <span [innerHtml]="'my-tasks.refunding-products' | translate"></span>,
                <strong>{{ task.providerName }}</strong>
            </div>
        </div>
        <span *ngIf="isDone" class="dynamic-done-label">
            {{ 'my-tasks.done' | translate }}
        </span>
        <i
            *ngIf="!isDone"
            class="fa dynamic-task-collapse-icon"
            [ngClass]="isCollapsed ? 'fa-angle-down' : 'fa-angle-up'"
            aria-hidden="true"
        ></i>
    </div>
    <div
        *ngIf="!isDone"
        class="card-body text-center dynamic-task-details"
        [collapse]="isCollapsed"
        [isAnimated]="true"
    >
        <h5 class="card-title">{{ task.customerName }}</h5>
        <div class="table-responsive dynamic-task-details-table">
            <table class="table table-striped table-borderless text-white">
                <tbody>
                    <tr>
                        <th scope="row">
                            {{ 'my-tasks.total-refunding-price' | translate }}:
                        </th>
                        <td>
                            {{ task.totalRefundPrice }}
                            {{ 'common.currency' | translate }}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.provider-shop' | translate }}:</th>
                        <td>{{ task.providerShop }}</td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.payment-type' | translate }}:</th>
                        <td>
                            {{
                                'payment-type.' +
                                    PaymentType[task.paymentType].toLowerCase()
                                    | translate
                            }}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.phone' | translate }}:</th>
                        <td>{{ task.customerPhone }}</td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.notes' | translate }}:</th>
                        <td>{{ task.notes }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf="!isDone" class="card-footer" [collapse]="isCollapsed" [isAnimated]="true">
        <app-refunding-task-button [task]="task"></app-refunding-task-button>
    </div>
</div>
